module.exports = __webpack_public_path__ + "img/group-13@3x.c82c98f5.png";